
import { TranslateService } from "@ngx-translate/core";
import { DateTime } from "luxon";


export function renderDate(data: any, type: string) {
    if (!type || (type === "sort" || type === "type")) {
        return data;
    }

    if(!data) return '';

    let dateTime = DateTime.fromISO(data)
    if(!dateTime.isValid) return '';

    return dateTime.toFormat('yyyy-MM-dd');
}

export function renderEnumTranslated(translateService: TranslateService, data: any, type: string) {
    if (!type || (type === "sort" || type === "type")) {
        return data;
    }

    return translateService.instant(data);
}

export function renderFromId(collection: any[], data: any, type: string) {
    if (!type || (type === "sort" || type === "type")) {
        return data;
    }

    var entry = collection.filter((element) => element.id === data);
    return entry.length === 0 ? '' : entry[0].name;
}